import { i18n } from "@lingui/core";

function utf8ToBase64(str: string) {
  const utf8Encoder = new TextEncoder();
  const bytes = utf8Encoder.encode(str);
  return window.btoa(String.fromCharCode(...new Uint8Array(bytes)));
}

export const PreviewBackgroundSVG = () => {
  const text = i18n.t({
    id: "itemPageLayout.preview.background.text",
    message: "Preview",
    comment: "Text used for the preview background",
  });

  const svgString = `
    <svg xmlns="http://www.w3.org/2000/svg" height="300px" width="300px">
      <text transform="translate(90, 200) rotate(-45)" fill="rgb(222, 222, 227)"
      font-size="24" font-family="Finntype,Arial,Helvetica,sans-serif">${text}</text>
    </svg>`;

  return `data:image/svg+xml;base64,${utf8ToBase64(svgString)}`;
};
